/* eslint-disable react/jsx-key */
import React from "react";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import wretch from "wretch";

const API_URL = "/api/v1/entities";

export default class TopicsPerson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      sorted: []
    };
  }

  componentDidMount() {
    const url = `${API_URL}?type=person&limit=200`;

    wretch(url)
      .get()
      .json(res => {
        const entities = res.entities;
        const sorted = entities.sort((a, b) => {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        this.setState({ sorted });
      });
  }
  render() {
    return (
      <div className="container">
        <div>
          <div>
            {/* <h2>Persons</h2>
            <hr /> */}
            <ul className={styles["ul-list"]}>
              {this.state.sorted.map(entity => (
                <li>
                  <Link href={`https://www.vikatan.com/topics/${entity.slug}`}>{entity.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div />
        </div>
      </div>
    );
  }
}

export { TopicsPerson };
